class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search-results');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // New: Bind the click-outside handler so we can add/remove it easily
    this.onOutsideClick = this.onOutsideClick.bind(this);
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        console.error(error);
      });
  }

  // --- New Functionality Starts Here ---

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
    
    // Disable Body Scroll
    document.body.style.overflow = 'hidden';

    // Listen for clicks outside
    document.addEventListener('click', this.onOutsideClick);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute('open');

    // Re-enable Body Scroll
    document.body.style.overflow = '';

    // Remove the listener to save memory
    document.removeEventListener('click', this.onOutsideClick);
  }

  onOutsideClick(event) {
    // If the click happened outside of this custom element (<predictive-search>)
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  // --- End of New Functionality ---

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);